import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";
import presensiProyekService from "./presensiProyekService";

const  projectPegawaiService = {}

projectPegawaiService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/project_pegawai/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

projectPegawaiService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/project_pegawai/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

projectPegawaiService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/project_pegawai/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

projectPegawaiService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/project_pegawai/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

export default projectPegawaiService;
